
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "GCOSFOH",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/GCOSFOH.vue